import AgentConfigurationScreen from '../../components/agents/AgentConfigurationScreen';
import {
  adminGetAgentConfiguration,
  adminUpsertAgentConfiguration,
  adminGenerateAgentConfiguration,
  adminAttachTwilioNumber,
  adminDetachTwilioNumber,
  patchAdminAgentFacebookEnabled,
} from '../../lib/api';

export default function AdminAgentConfigurationPage() {
  return (
    <AgentConfigurationScreen
      roleLabel="Admin"
      backPath={(agentId) => `/admin/agents/${agentId}`}
      getConfiguration={adminGetAgentConfiguration}
      saveConfiguration={adminUpsertAgentConfiguration}
      generateConfiguration={adminGenerateAgentConfiguration}
      attachTwilioNumber={adminAttachTwilioNumber}
      detachTwilioNumber={adminDetachTwilioNumber}
      patchFacebookEnabled={patchAdminAgentFacebookEnabled}
    />
  );
}
